const translations = {
  "en": {
    "and more": "and more",
    "Nothing here yet": "Nothing here yet",
    "Supports": "Supports"
  },
  "zh-tw": {
    "and more": "更多",
    "Nothing here yet": "目前尚無資料",
    "Supports": "支撐"
  }
};

export default translations;
